<div class="content">
  <div *ngIf="hideToggleButton" class="icon-wrapper">
    <i2g-icon class="lock-icon" name="lock" size="custom"></i2g-icon>
  </div>

  <i2g-icon *ngIf="icon" class="icon" [icon]="icon" (click)="clickIcon.emit()">
  </i2g-icon>

  <label
    class="toggle-label field-label"
    [ngClass]="{
      'sr-text': hideLabel,
      disabled: fieldControl?.disabled
    }"
    [attr.for]="fieldId"
    [attr.data-e2e-id]="labelE2eId"
    (click)="fieldControl?.enabled && click.emit($event)"
  >
    {{ label }}
  </label>

  <div class="children">
    <ng-content></ng-content>
  </div>

  <div class="h-spacer"></div>

  <i2g-toggle
    *ngIf="!hideToggleButton && !setupText"
    class="toggle-btn"
    [fieldId]="fieldId"
    [fieldControl]="fieldControl"
    [toggleInputE2eId]="toggleInputE2eId"
    [toggleLabelE2eId]="toggleLabelE2eId"
    [trackingIdentifier]="trackingIdentifier"
    [trackingAdditionalProperties]="trackingAdditionalProperties"
    [trackingScreenName]="trackingScreenName"
    [trackingObject]="trackingObject"
    (toggleClick)="fieldControl?.enabled && click.emit($event)"
  >
  </i2g-toggle>
  <a *ngIf="setupText" class="setup-text" (click)="clickSetup.emit()">
    {{ setupText }}
  </a>
</div>

<p *ngIf="description" class="description">
  {{ description }}
</p>

<div *ngIf="showDivider" class="divider"></div>
